// breadcrumb.service.ts

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

export interface BreadcrumbItem {
  title: string;
  url: string;
}

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  private breadcrumbStack: BreadcrumbItem[] = [];
  private routesToSave: string[] = [
    '/calculadora/puerta-interior/EDITAR', '/calculadora/puerta-interior/CREAR', 
    '/calculadora/puerta-chapa/EDITAR/PUERTA', '/calculadora/puerta-chapa/CREAR/PUERTA', 
    '/calculadora/puerta-chapa/EDITAR/PORTON', '/calculadora/puerta-chapa/CREAR/PORTON',
    '/calculadora/abertura-lista/EDITAR', '/calculadora/abertura-lista/CREAR', 
    '/calculadora/puerta-lista/EDITAR', '/calculadora/puerta-lista/CREAR', 
    '/calculadora/save-abertura-editable/EDITAR', '/calculadora/save-abertura-editable/CREAR',
    '/calculadora/abertura-lista/COMPONENTE_EDITABLE_EDITAR', '/calculadora/abertura-lista/COMPONENTE_EDITABLE_CREAR', 
    '/ventas/mis-clientes/save-abertura-editable-chapa/:id',
    '/ventas/mis-clientes/save-abertura-otra/:id'
  ]

  // Inyecta el servicio de Router en el constructor
  constructor(private router: Router) {
    // Cargar el breadcrumb desde el localStorage al iniciar el servicio
    const storedBreadcrumbs = localStorage.getItem('breadcrumbs');
    if (storedBreadcrumbs) {
      this.breadcrumbStack = JSON.parse(storedBreadcrumbs);
    }
  }

  getBreadcrumbs(): BreadcrumbItem[] {
    return this.breadcrumbStack;
  }

  pushBreadcrumb(item: BreadcrumbItem): void {
    const duplicateIndex = this.breadcrumbStack.findIndex(b => b.url === item.url);

    if (duplicateIndex !== -1) {
      this.breadcrumbStack.splice(duplicateIndex + 1);
    } else {
      this.breadcrumbStack.push(item);
    }

    // Guardar el breadcrumb en el localStorage solo si la ruta está permitida
    if (this.isRouteToSave(item.url)) {
      localStorage.setItem('breadcrumbs', JSON.stringify(this.breadcrumbStack));
    }
  }
  /**
   * 
   * @param item si 'item' se manda, quita el último breadcrumbItem y se cambia por 'item'
   * sino, sólo se quita el último breadcrumbItem ingresado
   */
  popBreadcrumb(item: BreadcrumbItem = null): void {
    if (item == null) {
      this.breadcrumbStack.pop();
    } else {
      this.breadcrumbStack.pop();
      this.pushBreadcrumb(item);
    }

    // Guardar el breadcrumb en el localStorage solo si la ruta está permitida
    if (this.isRouteToSave(this.breadcrumbStack[this.breadcrumbStack.length - 1]?.url)) {
      localStorage.setItem('breadcrumbs', JSON.stringify(this.breadcrumbStack));
    }
  }

  clearBreadcrumbs(): void {
    this.breadcrumbStack = [];
    localStorage.removeItem('breadcrumbs'); // Limpiar el localStorage
  }

  navigateToBreadcrumb(index: number): void {
    if (index >= 0 && index < this.breadcrumbStack.length) {
      this.breadcrumbStack.splice(index + 1);
      const destination = this.breadcrumbStack[index].url;
      this.router.navigateByUrl(destination);
      // Actualizar el localStorage solo si la ruta está permitida
      if (this.isRouteToSave(destination)) {
        localStorage.setItem('breadcrumbs', JSON.stringify(this.breadcrumbStack));
      }
    }
  }

  private isRouteToSave(url: string): boolean {
    return this.routesToSave.some(route => {
      const routeParts = route.split('/');
      const urlParts = url.split('/');
      if (routeParts.length !== urlParts.length) {
        return false;
      }
      return routeParts.every((part, index) => {
        return part === urlParts[index] || part.startsWith(':');
      });
    });
  }
}
